import { isScm, isCluster, isCustomer, isCustomerAdmin, isCustomerUser, isFe, isSp, isPsp, isIsp, isSuperVisor, isSpIsp, isCustomerGroup } from '../../utils/role';
import { useSelector } from 'react-redux';
import { getWalletPaymentStatus } from '../../actions/wallet';
import { closeModalAction, openCustomModal, openFullscreenModal, openTextModalAction } from '../../actions/modal';
import CancelPO from './Modals/CancelPO';
import { deletePoById, deletePoRequest } from '../../actions/payments';
import ManualPOInvoice from './Modals/ManualPOInvoice';
import PayPoTax from './Modals/PayPoTax';
import PayPo from './Modals/PayPO/index';
import GenerateInvoice from './Modals/GenerateInvoice';
import {
    isDeletePoAllowed,
    isViewPoAllowed,
    isViewWithdrawlsAllowed,
    isRefreshBankOpenBalanceAllowed,
    isApprovePaymentAllowed,
    isEditAllowedInAdditonalPayament,
    isViewWithdrawalsAllowed,
    isViewPOAllowed,
    isModifyPOAllowed,
} from '../../utils/access';
import { paymentsSidebarTab } from '../../layout/sidebar/index';
import PoApproval from '../Ticket/PoApproval';
import { payments } from '../../router/roleWisePageRoute';
import { ScogoID } from '../../utils/common';
import { ReportsName } from '../../utils/utils';
import RequestStatement from '../Wallet/Modals/RequestStatement';

export const payoutsTab = {
    tabName: 'Payouts',
    tabID: 'payouts',
    path: 'payouts',
    tabIcon: '',
    iconSize: 'text-3xl',
};

export const withdrawlTab = {
    tabName: 'Withdrawls',
    tabID: 'withdraw',
    path: 'withdraw',
    tabIcon: '',
    iconSize: 'text-3xl',
};

export const PoTab = {
    tabName: 'PO',
    tabID: 'po',
    path: 'po',
    tabIcon: '',
    iconSize: 'text-3xl',
};

export const rewardsTab = {
    tabName: 'Rewards',
    tabID: 'rewards',
    path: 'rewards',
    tabIcon: '',
    iconSize: 'text-3xl',
};

export const openTicketPaymentsTab = {
    tabName: 'Open Ticket Payments',
    tabID: 'openTickets',
    path: 'openTickets',
    tabIcon: '',
    iconSize: 'text-3xl',
};

const refreshPayoutAction = {
    key: 'refresh_payout_action',
    menuName: 'Refresh',
    menuIcon: 'refresh',
    onClick: (transaction, dispatch) => {
        const { scogo_transaction_no } = transaction;
        return dispatch(getWalletPaymentStatus({ scogo_transaction_no }));
    },
};

export const paymentMode = {
    partner: 'PARTNER',
    customer: 'CUSTOMER',
    cluster: 'CLUSTER',
    psp: 'PSP',
    supervisor: 'SUPERVISOR',
    warehouseOwner: 'WAREHOUSE_OWNER',
};

export const additionalPaymentStatus = {
    pending: 'Pending',
    scheduled: 'Scheduled',
    success: 'Success',
    failure: 'Failure',
};

const cancelPO = {
    key: 'cancel_po',
    menuName: 'Cancel PO',
    menuIcon: 'highlight_off',
    onClick: (po, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: (
                    <>
                        Cancel PO | <span className='text-scogobgsky'>{po.pr_number}</span>
                    </>
                ),
                modalWidth: '40rem',
                modalHeight: 'auto',
                modalComponent: <CancelPO po={po} isRefresh />,
            })
        );
    }
};

const deletePO = {
    key: 'delete_po',
    menuName: 'Delete PO',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (po, dispatch) => {
        const formName = 'deletePO';
        return dispatch(
            openTextModalAction({
                heading: `Delete PO | ${po.pr_number}`,
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        onClick: () => {
                            dispatch(deletePoById({ id: po.id, formName }));
                        },
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};

const manualInvoice = {
    key: 'manual_po_invoice',
    menuName: 'Enter Manual Invoice',
    menuIcon: 'contact_page',
    onClick: (po, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: (
                    <>
                        Enter Manual Invoice | <span className='text-scogobgsky'>{po.pr_number}</span>
                    </>
                ),
                modalWidth: '100rem',
                modalHeight: 'auto',
                modalComponent: <ManualPOInvoice po={po} />,
            })
        );
    },
};

const updatePo = {
    key: 'update_po',
    menuIcon: 'update',
    conditionalRendering: (po) => {
        return { menuName: po?.status === 'CANCELLED' ? 'Reopen PO' : 'Update PO' };
    },
    onClick: (po, dispatch, { navigate } = {}) => {
        navigate(`${payments.path}/po/${po.id}`);
    },
};

const payPOTax = {
    key: 'pay_po_tax',
    menuName: 'Pay PO Tax',
    menuIcon: 'percent',
    onClick: (ticket, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: (
                    <>
                        Pay PO Tax | <span className='text-scogobgsky'>{ticket.prNumber}</span>
                    </>
                ),
                modalWidth: '70rem',
                modalHeight: 'auto',
                modalComponent: <PayPoTax ticketId={ticket.ticketId} vendorId={ticket?.po?.vendorId} isRefresh paymentDetails={ticket?.paymentDetails} enduserId={ticket.enduserId} />,
            })
        );
    },
};

const generateInvoice = {
    key: 'generate_invoice',
    menuName: 'Generate System Invoice',
    menuIcon: 'description',
    onClick: (po, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: (
                    <>
                        Generate System Invoice | <span className='text-scogobgsky'>{po.pr_number}</span>
                    </>
                ),
                modalWidth: '85vw',
                modalHeight: 'auto',
                modalComponent: <GenerateInvoice po={po} isRefresh />,
            })
        );
    }
};

export const approvePo = {
    key: 'approve_po',
    menuName: 'Approve PO',
    menuIcon: 'update',
    iconColor: 'text-scogoprimary',
    onClick: (po, dispatch) => {
        let modalComponent = <PoApproval poId={po.id} />;
        dispatch(openFullscreenModal({ modalComponent }));
    },
};


const payPo = {
    key: 'pay_po',
    menuName: 'Pay PO',
    menuIcon: 'currency_rupee',
    onClick: (ticket, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: `Pay PO | ${ticket.prNumber}`,
                modalWidth: '90rem',
                modalHeight: 'auto',
                modalComponent: <PayPo ticket={ticket} isRefresh />,
            })
        );
    },
    // isDisabled: (ticket) => {
    //     return {
    //         disabled: ticket.po.status === 'CANCELLED' || ticket.po.status !== 'APPROVED',
    //         message: ticket.po.status === 'CANCELLED' ? 'PO is CANCELLED' : 'Only allowed to Pay on Approved PO',
    //     };
    // },
};

export const getPaymentsMainTabs = (newLoggedUserData) => {
    let tabs = [payoutsTab, openTicketPaymentsTab, withdrawlTab, PoTab];
    return tabs.filter((tab) => {
        switch (tab.tabID) {
            case withdrawlTab.tabID:
                return isViewWithdrawalsAllowed(newLoggedUserData.actions);

            case PoTab.tabID:
                return isViewPOAllowed(newLoggedUserData.actions);

            case payoutsTab.tabID:
            case openTicketPaymentsTab.tabID:
                return newLoggedUserData.orgMemberships.find((membership) => membership.id === ScogoID);

            default:
                return true;
        }
    });
};

export const getPaymentsDefaultTab = ({ newLoggedUserData, urlQueryString, }) => {
    const tabs = getPaymentsMainTabs(newLoggedUserData);
    let tab = tabs[0];
    if (urlQueryString) {
        const { matchingTab } = getTabFromQueryString(tabs, urlQueryString);
        if (matchingTab) {
            tab = matchingTab;
        }
    }
    return tab?.tabID;
};

const getPaymentsModuleTitle = (role, type, frontend_controller) => {
    return typeof paymentsSidebarTab.name === 'function' ? paymentsSidebarTab.name(role, type, frontend_controller) : paymentsSidebarTab.name;
};

export const getpaymentAddNewButton = (tab) => {
    return false;
};

const getTabFromQueryString = (tabs, urlQueryString) => {
    const match = urlQueryString.match(/[\?&]tab=(\w+)/);
    let queryTab;
    if (match) queryTab = match[1];
    const matchingTab = tabs.find((tab) => tab.path === queryTab);
    if (matchingTab) return { matchingTab };
    return {};
};

export const getPOActions = ({ po, newLoggedUserData }) => {
    let actions = [cancelPO, updatePo, approvePo, generateInvoice, manualInvoice, deletePO];
    return actions.filter((action) => {
        if (action.key === approvePo.key) {
            return po.status !== 'APPROVED' && po.approvers.map((approver) => approver.user_id).includes(newLoggedUserData.user.id);
        };

        if (action.key === cancelPO.key) {
            return isModifyPOAllowed(newLoggedUserData.actions) && po.status !== 'CANCELLED';
        }

        if ([updatePo.key, deletePO.key, manualInvoice.key, generateInvoice.key].includes(action.key)) {
            return isModifyPOAllowed(newLoggedUserData.actions);
        }
        return true;
    });
};

const getIsToShowAdditionalPaymentEditIcon = (frontend_controller) => {
    return isEditAllowedInAdditonalPayament(frontend_controller);
};

const isPayoutActionAllowed = (frontend_controller) => {
    return isApprovePaymentAllowed(frontend_controller);
};

export const GetPaymentsListLogic = (logic, { urlQueryString, tabID, ticket } = {}) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id,
        type = loggedUser.type,
        frontend_controller = loggedUser.frontend_controller;
    if (logic === 'defaultTab') return getPaymentsDefaultTab(role, type, frontend_controller, { urlQueryString, manage_partner_payments: loggedUser.manage_partner_payments });
    if (logic === 'tabs') return getPaymentsMainTabs(role, type, frontend_controller, loggedUser.manage_partner_payments);
    if (logic === 'getPoActions') return getPOActions(role, type, { frontend_controller, ticket, user: loggedUser });
    if (logic === 'isToShowBasePaymentColumnInTicketPaymentDetails') return !isCustomer(role, type) && !isCustomerAdmin(role, type) && !isCustomerUser(role, type);
    if (logic === 'isToShowPaymentBasePaymentInTicketDetails') return isScm(role, type) || isCluster(role, type) || isPsp(role, type) || isSpIsp(role, type) || isSp(role, type);
    if (logic === 'isToShowPaymentColumn')
        return (
            isScm(role, type) ||
            isCluster(role, type) ||
            isPsp(role, type) ||
            isSpIsp(role, type) ||
            isSp(role, type) ||
            isCustomer(role, type) ||
            isCustomerAdmin(role, type) ||
            isCustomerUser(role, type)
        );
    if (logic === 'isFeOrSps') return isFe(role, type) || isPsp(role, type) || isSpIsp(role, type) || isSp(role, type);
    if (logic === 'isToShowCustomer') return isScm(role, type);
    if (logic === 'isToShowExportCSVButton') return getIsToShowExportCSVButton(role, type, tabID);
    if (logic === 'isToShowDownloadZipButton') return getIsToShowDownloadZipButton(role, type, tabID);
    if (logic === 'isToShowAdditionalPaymentEditIcon') return getIsToShowAdditionalPaymentEditIcon(frontend_controller);
    if (logic === 'isToShowBalanceRefreshButton') return getIsToShowBalanceRefreshButton(role, type, { frontend_controller, tabID });
    if (logic === 'isToShowApproveOrTriggerAndEditButton') return isPayoutActionAllowed(frontend_controller);
    if (logic === 'paymentsModuleTitle') return getPaymentsModuleTitle(role, type);
};

const getIsToShowExportCSVButton = (role, type, tabID) => {
    const isUserHaveRoleSix = isScm(role, type) || isCluster(role, type) || isSuperVisor(role, type);
    if (tabID === payoutsTab.tabID) return isScm(role, type) || isCluster(role, type);
    else if (tabID === PoTab.tabID) return isUserHaveRoleSix || isIsp(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCustomerUser(role, type);
    return false;
};

const getIsToShowDownloadZipButton = (role, type, tabID) => {
    const isPoTab = tabID === PoTab.tabID;
    return (
        isPoTab &&
        (isScm(role, type) ||
            isCluster(role, type) ||
            isSuperVisor(role, type) ||
            isIsp(role, type) ||
            isCustomer(role, type) ||
            isCustomerAdmin(role, type) ||
            isCustomerUser(role, type))
    );
};

const getIsToShowBalanceRefreshButton = (role, type, { frontend_controller, tabID }) => {
    const isPayoutsTab = tabID === payoutsTab.tabID;
    return isPayoutsTab && isScm(role, type) && isRefreshBankOpenBalanceAllowed(frontend_controller);
};

export const GetRateCardObject = (logic, { ratecards } = {}) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const roleId = loggedUser?.role?.id;
    const type = loggedUser.type;
    if (logic === 'rateCard') return getRateCard(roleId, type, ratecards);
};

const getRateCard = (roleId, type, ratecards) => {
    if (isScm(roleId, type) || isCluster(roleId, type)) return ratecards?.['sp'];
    else return ratecards;
};

export const defaultRowsPerPage = 10;
export const defaultPage = 1;

export const requestRaised = {
    pendingForApproval: 1,
    approved: 2,
    rejected: 3,
    success: 4,
};

export const paymnetVia = {
    throughWallet: 1,
    throughBank: 0,
};

export const taxDeductionPercentage = ({ is_pancard_linked_with_aadhaar }) => {
    return is_pancard_linked_with_aadhaar === 1 ? 0.02 : 0.2;
};



export const TransactionStatus = {
    INITIATED: "INITIATED",
    PENDING: "PENDING",
    SCHEDULED: "SCHEDULED",
    PROCESSING: "PROCESSING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    REJECTED: "REJECTED",
    HOLD: "HOLD",
};

export const PaymentChannel = {
    OFFLINE: "OFFLINE",
    WALLET: "WALLET",
    BANK: "BANK",
};

export const showPayPoButtons = ({ payment_status, newLoggedUserData }) => {
    return ['PENDING', 'FAILURE', 'REJECTED'].includes(payment_status) && newLoggedUserData.org.id === ScogoID;
};


export const getPoStatusColor = (status) => {
    if (status === 'CANCELLED' || status === 'REJECTED') {
        return 'text-scogoclosed';
    } else if (status === 'APPROVED') {
        return 'text-scogo2e';
    } else if (status === 'OPEN') {
        return 'text-scogo2e';
    } else if (status === 'DRAFT') {
        return 'text-scogogray';
    } else if (status === 'ACKNOWLEDGED') {
        return 'text-scogobgsky';
    } else if (status === 'PENDING') {
        return 'text-scogoorange';
    } else if (status && typeof status === 'string' && status.toLowerCase().includes('pending')) {
        return 'text-scogoorange';
    }
    return 'text-black';
};


export const InvoicePaymentStatus = {
    PENDING: 'PENDING',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    HALTED: 'HALTED',
    CANCELLED: 'CANCELLED',
}

export const getInvoiceStatusColor = (status) => {
    if (status === InvoicePaymentStatus.CANCELLED) {
        return 'text-red-800';
    } else if (status === InvoicePaymentStatus.PAID) {
        return 'text-green-800';
    } else if (status === InvoicePaymentStatus.PARTIALLY_PAID) {
        return 'text-orange-800';
    } else if (status === InvoicePaymentStatus.PENDING) {
        return 'text-orange-800';
    } else if (status === InvoicePaymentStatus.OVERDUE) {
        return 'text-orange-800';
    } else if (status === InvoicePaymentStatus.HALTED) {
        return 'text-gray-800';
    }
    return 'text-black';
};


export const TransactionStatusColor = {
    INITIATED: "text-scogogray",
    PENDING: "text-scogoorange",
    SCHEDULED: "text-scogoorange",
    PROCESSING: "text-scogoorange",
    SUCCESS: "text-scogo2e",
    FAILURE: "text-scogoclosed",
    REJECTED: "text-scogoclosed",
};


export const getDownloadReportActions = ({ newLoggedUserData }) => {
    return [
        {
            key: 'download_report',
            menuName: 'FE expense report',
            imgIcon: './img/csvdownload.png',

            menuIconColor: 'text-scogoorange',
            onClick: (_, dispatch, { onClick }) => {
                return onClick();
            }
        },
        {
            key: 'download_report',
            menuName: 'TDS Report',
            imgIcon: './img/csvdownload.png',
            menuIconColor: 'text-scogoorange',
            onClick: (_, dispatch) => {

                let modalWidth = '60rem', modalHeight = 'auto';
                let modalComponent = <RequestStatement report={ReportsName.EXPENSE_TDS} filterData={{}} />
                let head = 'Download TDS Report';
                return dispatch(openCustomModal({ modalWidth, modalHeight, modalComponent, heading: head }));
            }
        }
    ];
};